import { render } from "./MedicalDashboard.vue?vue&type=template&id=5672536d&scoped=true"
import script from "./MedicalDashboard.vue?vue&type=script&lang=js"
export * from "./MedicalDashboard.vue?vue&type=script&lang=js"

import "./MedicalDashboard.vue?vue&type=style&index=0&id=5672536d&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5672536d"]])

export default __exports__